/**
 * Exposed API through OMFECore.api.doSomething()
 */
import provideCall, { onPendingCallsUpdate } from './api-provisioning/provideCall';
import provideOMFETopic, { onSubscriptionsUpdate, onSubscribersUpdate } from './api-provisioning/provideOMFETopic';

let currentUUID = Date.now();
export default class api {

    /**
     * Creates UUIDs for Requests
     */
    static createClientRequestId() {
        return (++currentUUID).toString(16);
    }

    /**
     * Installs a callable on the API Object
     */
    static addMethod(methodName = '', actualMethod = () => {}) {
        if (!methodName || typeof methodName !== 'string' || !methodName.length) {
            throw new Error(`Invalid method name supplied: ${methodName}`);
        }

        if (typeof actualMethod !== 'function') {
            throw new Error('Invalid parameter supplied to `addMethod` - must be callable');
        }

        if (this[methodName]) {
            throw new Error(`Method ${methodName} already installed on API`);
        }

        Object.defineProperty(this, methodName, {
            enumerable: true,
            configurable: false,
            get: () => actualMethod,
            set: () => {},
        });
    }


    /**
     * Creates a new method in the API that executes a specific RPC on the server
     */
    static provideCall(...params) {
        const { callMethodName, call, cancelCallMethodName, cancelCall } = provideCall(...params);
        this.addMethod(callMethodName, call);
        this.addMethod(cancelCallMethodName, cancelCall);
    }

    // Handlers - call a function every time calls list is updated
    static onPendingCallsUpdate(...params) {
        return onPendingCallsUpdate(...params);
    }

    /**
     * Creates a new method in the API that performs an OMFE registration & initial dump
     */
    static provideOMFETopic(...params) {
        const { subscribeMethodName, subscribe, unsubscribeMethodName, unsubscribe } = provideOMFETopic(...params);
        this.addMethod(subscribeMethodName, subscribe);
        this.addMethod(unsubscribeMethodName, unsubscribe);
    }

    // Handlers 1 - call a function every time subscribers list is updated
    static onSubscribersUpdate(...params) {
        return onSubscribersUpdate(...params);
    }

    // Handlers 2 - call a function every time subscriptions list is updated; subscriptions list is basically subscribers merged
    static onSubscriptionsUpdate(...params) {
        return onSubscriptionsUpdate(...params);
    }
}


/**
 * Install All the Methods on the Singleton
 *
 */
/* eslint import/newline-after-import: 0 */
import rpcOperatorInfo from './api-sports/rpc-operator-info';
rpcOperatorInfo(api);

import rpcDisciplines from './api-sports/rpc-disciplines';
rpcDisciplines(api);

import rpcEventParts from './api-sports/rpc-event-parts';
rpcEventParts(api);

import rpcEventInfoTypeUsage from './api-sports/rpc-event-info-type-usage';
rpcEventInfoTypeUsage(api);

import rpcEventPartDefaultUsage from './api-sports/rpc-event-part-default-usage';
rpcEventPartDefaultUsage(api);

import rpcNextMatches from './api-sports/rpc-next-matches';
rpcNextMatches(api);

import rpcMatches from './api-sports/rpc-matches';
rpcMatches(api);

import subSportsBannerData from './api-sports/sub-sports-banner-data';
subSportsBannerData(api);

import subMatch from './api-sports/sub-match';
subMatch(api);

import subEventInfo from './api-sports/sub-event-info';
subEventInfo(api);

import subMatchOdds from './api-sports/sub-match-odds';
subMatchOdds(api);

import rpcInitialDump from './api-sports/rpc-initial-dump';
rpcInitialDump(api);

import subSingleOdds from './api-sports/sub-single-odds';
subSingleOdds(api);



// WEBPACK FOOTER //
// ./src/OMFECore/enhanced-webapi/api.js